module.exports = __webpack_public_path__ + "static/media/ccx-monitor-icon.345783e0.png";